import { useMemo, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';

const ALERT_CLASS_MAP = {
    info: 'alert-info',
    success: 'alert-success',
    warning: 'alert-warning',
    error: 'alert-danger',
};
const AlertMessage = ({ messages = [], onClose, maxLimit = 5 }) => {
    const visibleMessages = useMemo(
        () => (maxLimit && messages.length > maxLimit ? messages.slice(-maxLimit) : messages),
        [messages.length, maxLimit]
    );

    useEffect(() => {
        if (maxLimit && messages.length > maxLimit) {
            onClose(visibleMessages);
        }
    }, [messages.length, maxLimit]);

    if (!visibleMessages.length) return null;
    return (
        <>
            {visibleMessages.map(({ id, text, type = 'info' }) => (
                <div
                    key={id}
                    className={`alert ${ALERT_CLASS_MAP[type]} d-flex justify-content-between align-items-center border-radius-10`}
                    role="alert"
                >
                    <span className="fw-bold font-size-15">{text}</span>
                    <i
                        className="fa fa-times font-size-15 cursor-pointer"
                        onClick={() => onClose(messages.filter((message) => message.id !== id))}
                    />
                </div>
            ))}
        </>
    );
};

AlertMessage.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
        })
    ).isRequired,
    onClose: PropTypes.func.isRequired,
    maxLimit: PropTypes.number,
};

export default AlertMessage;

export const createAlert = (text, type = 'info') => ({
    id: uuid(),
    text,
    type,
});